// FORM RULES
// ====================================
// These are arrays of objects that are fed into rc-form as the validation rules.

// PHONE INPUT
// ====================================
const DEFAULT_EMAIL_RULES = [
  {
    required: true,
    message: 'An email is required.',
  },
  {
    type: 'email',
    message: 'Input valid email address',
  },
  {
    max: 100,
    message: 'Must be no more than 100 characters!',
  },
];

// PHONE INPUT
// ====================================
const DEFAULT_PHONE_RULES = [
  {
    required: true,
    message: 'A mobile phone number is required ',
  },
  {
    max: 14,
    message: 'Can not be more than  14 characters ',
  },
  {
    min: 14,
    message: 'Must be at least 14 numbers ',
  },
];

// BASIC TEXT INPUT
// ====================================
const DEFAULT_BASIC_RULES = [
  {
    required: true,
    message: 'This is required. ',
  },
  {
    max: 100,
    message: 'Can not be more than  100 characters ',
  },
];

// PASSWORD INPUT
// ====================================
const DEFAULT_PASSWORD_RULES = [
  {
    required: true,
    message: 'Input password',
  },
  {
    max: 25,
    message: 'Less than 25 characters please ',
  },
];

export default {
  defaultEmailRules: DEFAULT_EMAIL_RULES,
  defaultPasswordRules: DEFAULT_PASSWORD_RULES,
  defaultPhoneRules: DEFAULT_PHONE_RULES,
  defaultBasicRules: DEFAULT_BASIC_RULES,
};



// WEBPACK FOOTER //
// ./src/lib/form-config/index.js